var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefreshActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7902 3L9.64408 4.14645C9.44887 4.34171 9.44887 4.65829 9.64408 4.85355C9.8393 5.04882 10.1558 5.04882 10.351 4.85355L11.5022 3.70208C12.1659 3.03819 12.1659 1.96181 11.5022 1.29792L10.351 0.146447C10.1558 -0.0488157 9.8393 -0.0488157 9.64408 0.146447C9.44887 0.341709 9.44887 0.658291 9.64408 0.853553L10.7902 2L1.20975 2L2.35592 0.853552C2.55113 0.65829 2.55113 0.341708 2.35592 0.146446C2.1607 -0.0488162 1.8442 -0.0488162 1.64899 0.146446L0.497797 1.29792C-0.165933 1.96181 -0.165931 3.03819 0.497796 3.70208L1.64899 4.85355C1.8442 5.04881 2.1607 5.04881 2.35592 4.85355C2.55113 4.65829 2.55113 4.34171 2.35592 4.14645L1.20975 3L10.7902 3Z",
    fill: "#0090D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshActive);
export default __webpack_public_path__ + "static/media/refresh-active.3540480688b993ba2232480956c8a5f1.svg";
export { ForwardRef as ReactComponent };